import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebaseConfig';
import QuestionDisplay from './QuestionDisplay';
import Scorecard from './Scorecard';
import './game.css';

function getJoinUrl() {
  if (typeof window === 'undefined') {
    return 'https://placeholder.com';
  }

  const url = new URL(window.location.href);
  url.hash = '';
  return url.href.replace(/\/$/, '');
}

function getDisplayJoinUrl(joinUrl) {
  try {
    const url = new URL(joinUrl);
    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      return 'placeholder.com';
    }

    return `${url.host}${url.pathname}`.replace(/\/$/, '');
  } catch {
    return 'placeholder.com';
  }
}

const App = () => {
  const [isTriviaOn, setIsTriviaOn] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(false);
  const [isShowScorecard, setIsShowScorecard] = useState(false);
  const joinUrl = getJoinUrl();
  const displayJoinUrl = getDisplayJoinUrl(joinUrl);
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(joinUrl)}`;
  const joinCard = (
    <div className="join-panel join-panel-lobby">
      <div className="join-card-header">
        <span className="guest-pass-label">Party Pass</span>
        <span className="guest-pass-dots" aria-hidden="true"></span>
      </div>
      <div>
        <div className="join-kicker">Scan To Join The Party</div>
        {/* <div className="join-url">{displayJoinUrl}</div> */}
      </div>
      <div className="qr-frame">
        <img className="join-qr" alt={`QR code for ${displayJoinUrl}`} src={qrCodeUrl} />
      </div>
      <div className="join-steps">
        <div><strong>1</strong><span>Open on your phone</span></div>
        <div><strong>2</strong><span>Tap Start</span></div>
        <div><strong>3</strong><span>Enter your name</span></div>
      </div>
    </div>
  );
  const compactJoinCard = (
        <div className="join-panel join-panel-compact">
      <div>
        <div className="join-kicker">Join the party</div>
        {/* <div className="join-url">{displayJoinUrl}</div> */}
      </div>
      <img className="join-qr" alt={`QR code for ${displayJoinUrl}`} src={qrCodeUrl} />
    </div>
  );

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {
      const data = doc.data();
      setIsTriviaOn(Boolean(data?.isOn))
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "currentQuestion", "UEsaFssIIvcTBHM9hejH"), (doc) => {
      const data = doc.data();
      setCurrentQuestion(data?.id || "")
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isShowScorecard", "MQyyHk4Q8g1UonUg7ZNc"), (doc) => {
      const data = doc.data();
      setIsShowScorecard(Boolean(data?.isShowScorecard))
    });
    return () => unsub();
  }, []);

  return (
    <div className="game-shell show-screen">
      {
        isShowScorecard &&
        <Scorecard></Scorecard>
      }
      {
        !isShowScorecard && <>
          {
            (!isTriviaOn || (isTriviaOn && !currentQuestion)) &&
            <div className="game-stage show-lobby-stage">
              <div className="game-panel game-lobby show-lobby">
                <div className="show-lobby-copy">
                  <div className="party-sign party-sign-small show-lobby-sign">
                    <span>Desi</span>
                    <strong>50+</strong>
                  </div>
                  <p className="game-kicker">50+ Desi Couples Trivia Night</p>
                  <h1 className="game-title">Good Times, Great Company</h1>
                  <p className="game-subtitle">Join on your phone, enter your name, and get ready for a lively evening of memories, laughs, and friendly competition.</p>
                  <div className="show-lobby-garland" aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                {joinCard}
              </div>
            </div>
          }
          {
            isTriviaOn && currentQuestion && <>
              <QuestionDisplay joinCard={compactJoinCard}></QuestionDisplay>
            </>
          }
        </>
      }
    </div>
  );
};

export default App;

